export const Message = {
    AT_LEAST_SELECT_SINGLE_RECORD : "Please select at least a single row",
    SELECT_SINGLE_RECORD : "Please select a single row",
    SELECT_MULTIPLE_RECORD : "Please select more than one row",
    CONFIRMATION_POPUP_MESSAGE : "Do you want to continue?",
    SUCCESSFULLY: "successfully",
    FORM_NOT_DEFINE: "Form is not define"
};